"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNumberFormat = require("react-number-format");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _styles = require("@mui/material/styles");
var _fonts = _interopRequireDefault(require("../../theme/fonts"));
var _system = require("@mui/system");
var _theme = require("../../theme");
var _excluded = ["allowleadingzeros", "inputRef", "onChange", "onBlur"],
  _excluded2 = ["allowleadingzeros", "allowNegative", "inputRef", "onChange", "onBlur", "decimalscale"],
  _excluded3 = ["allowleadingzeros", "inputRef", "onChange", "onBlur", "decimalscale", "limitonehundred"];
/* eslint-disable require-jsdoc */
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var StyledTextField = (0, _styles.styled)(_TextField["default"])(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiInputBase-root': {
      fontFamily: '"AvenirLTPro-Book", sans-serif',
      fontWeight: 400,
      color: theme.palette["default"].contrastText,
      // this keeps letter spacing consistent with site before mui5 upgrade
      letterSpacing: "0.14994px"
    },
    "& .MuiOutlinedInput-root:hover:not(.Mui-disabled):not(.Mui-error):before": {
      borderColor: theme.palette.custom.textFieldHover
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-error):before": {
      borderColor: theme.palette.custom.textFieldHover,
      borderBottomWidth: "2px"
    }
  };
});

/**
 *
 * @param {*} props
 */
var NumberFormatCustom = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var allowleadingzeros = props.allowleadingzeros,
    inputRef = props.inputRef,
    onChange = props.onChange,
    _onBlur = props.onBlur,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat.NumericFormat, (0, _extends2["default"])({}, other, {
    getInputRef: ref,
    onChange: function onChange(e) {
      return e.stopPropagation();
    },
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          value: values.value
        }
      });
    },
    onBlur: function onBlur(e) {
      _onBlur({
        target: {
          value: Number(e.target.value.replace('$', '').replace('%', '').replaceAll(',', '').trim())
        }
      });
    },
    allowNegative: false,
    allowLeadingZeros: Boolean(allowleadingzeros)
  }));
});

/**
 *
 * @param {*} props
 */
var NumberFormatCurrency = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var allowleadingzeros = props.allowleadingzeros,
    allowNegative = props.allowNegative,
    inputRef = props.inputRef,
    onChange = props.onChange,
    _onBlur2 = props.onBlur,
    decimalscale = props.decimalscale,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat.NumericFormat, (0, _extends2["default"])({}, other, {
    ref: ref

    // the following two props are used to save values
    ,
    onChange: function onChange(e) {
      return e.stopPropagation();
    },
    onBlur: function onBlur(e) {
      _onBlur2({
        target: {
          value: Number(e.target.value.replace('$', '').replace('%', '').replaceAll(',', '').trim())
        }
      });
    }

    // this prop is used to set the internal value of the component, and interacts with the label component etc
    ,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          value: values.value
        }
      });
    },
    thousandSeparator: true,
    prefix: "$",
    decimalScale: decimalscale || 2,
    fixedDecimalScale: true,
    allowNegative: allowNegative,
    allowLeadingZeros: Boolean(allowleadingzeros)
  }));
});

/**
 *
 * @param {*} props
 * todo: make this work
 */
var NumberFormatPercentage = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var allowleadingzeros = props.allowleadingzeros,
    inputRef = props.inputRef,
    onChange = props.onChange,
    _onBlur3 = props.onBlur,
    decimalscale = props.decimalscale,
    limitonehundred = props.limitonehundred,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded3);
  var MAX_LIMIT = 100;
  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat.NumericFormat, (0, _extends2["default"])({}, other, {
    getInputRef: inputRef,
    isAllowed: function isAllowed(values) {
      var value = values.value;
      // this will limit the value to 100, and will still allow the user to enter in 0
      return value === undefined || value <= MAX_LIMIT;
    },
    onChange: function onChange(e) {
      return e.stopPropagation();
    },
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          value: values.value >= 100 && limitonehundred === "true" ? 100 : values.value
        }
      });
    },
    onBlur: function onBlur(e) {
      _onBlur3({
        target: {
          value: Number(e.target.value.replace('$', '').replace('%', '').replaceAll(',', '').trim())
        }
      });
    },
    suffix: "%",
    decimalScale: decimalscale || 2,
    fixedDecimalScale: true,
    allowNegative: false,
    allowLeadingZeros: false
  }));
});

/**
 *
 * @param {*} props
 */
var NumberInput = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var id = props.id,
    testid = props.testid,
    select = props.select,
    error = props.error,
    helperText = props.helperText,
    customHelperTextProps = props.customHelperTextProps,
    label = props.label,
    value = props.value,
    autoFocus = props.autoFocus,
    _props$margin = props.margin,
    margin = _props$margin === void 0 ? 'normal' : _props$margin,
    min = props.min,
    onChange = props.onChange,
    onKeyPress = props.onKeyPress,
    onBlur = props.onBlur,
    fullWidth = props.fullWidth,
    _props$autoComplete = props.autoComplete,
    autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete,
    allowLeadingZeros = props.allowLeadingZeros,
    allowNegative = props.allowNegative,
    required = props.required,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'standard' : _props$variant,
    disabled = props.disabled,
    prefix = props.prefix,
    suffix = props.suffix,
    decimalPlaces = props.decimalPlaces,
    limitonehundred = props.limitonehundred;
  var theme = (0, _system.useTheme)();
  var NumberFormatType = NumberFormatCustom;
  if (prefix) {
    NumberFormatType = NumberFormatCurrency;
  }
  if (suffix) {
    NumberFormatType = NumberFormatPercentage;
  }
  var style = _objectSpread({
    backgroundColor: props.disabled ? '#f7f7f7' : null,
    // this sets the outline of the border when hovered
    '& .MuiOutlinedInput-root': {
      "&:hover fieldset": {
        // sets the border color of the outlined variant only if not disabled and no error present
        borderColor: !props.error && !props.disabled && theme.palette.custom.textFieldHover
      }
    },
    "& .MuiInputBase-input.Mui-disabled": {
      // sets the color of the disabled field text
      WebkitTextFillColor: _theme.colors.mainTextGrey
    }
  }, props.customStyle || {});
  return /*#__PURE__*/_react["default"].createElement(StyledTextField, {
    id: id || testid,
    select: select,
    ref: ref,
    error: Boolean(error),
    helperText: helperText || error,
    FormHelperTextProps: {
      style: _objectSpread({
        fontFamily: _fonts["default"].type.base
      }, customHelperTextProps)
    },
    label: label,
    value: value,
    autoFocus: autoFocus,
    InputLabelProps: {
      style: {
        fontFamily: _fonts["default"].type.light,
        color: theme.primary
      }
    },
    margin: margin // none, dense, or normal
    ,
    min: min,
    onChange: onChange,
    onKeyPress: onKeyPress,
    onBlur: onBlur,
    fullWidth: fullWidth,
    InputProps: {
      autoComplete: autoComplete,
      inputComponent: NumberFormatType
    },
    sx: style,
    inputProps: {
      allowleadingzeros: allowLeadingZeros || "false",
      decimalscale: decimalPlaces || 2,
      limitonehundred: limitonehundred || "true",
      allowNegative: allowNegative || false
    },
    required: required,
    variant: variant || 'standard',
    disabled: disabled
  });
});
var _default = exports["default"] = NumberInput;